import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'yolda-web-ui'

import { StyledUserInviteErrorView } from './UserInviteErrorView.style'

const USER_ALREADY_EXISTS_ERROR_CODE = 'USER_ALREADY_EXISTS_FOR_CARRIER'

type UserInviteErrorView = {
  errorCode?: string
  metadata?: string[]
  onClose: () => void
}

const UserInviteErrorView: FC<UserInviteErrorView> = ({ errorCode, metadata, onClose }) => {
  const { t } = useTranslation()

  const isUserAlreadyExists = errorCode === USER_ALREADY_EXISTS_ERROR_CODE

  const renderError = () => {
    if (isUserAlreadyExists) {
      return t(`Schema.ResponseErrorCodes.${errorCode}${metadata ? `-${metadata?.[0]}` : ''}`)
    }

    return t(`Schema.ResponseErrorCodes.${errorCode}`)
  }

  return (
    <StyledUserInviteErrorView>
      <p>{renderError()}</p>
      <Button
        stretch
        onClick={() => {
          onClose?.()
        }}
        variant="outline"
      >
        {t('modal.labels.ok')}
      </Button>
    </StyledUserInviteErrorView>
  )
}

export default UserInviteErrorView
